export default "__VITE_ASSET__8da0f075__"